import { Component, Input, OnInit } from '@angular/core';

import { DatiqCellChangeService } from './services';
import { IDatiqCellChange } from './models';

@Component({
    selector: 'datiq-cell-change',
    templateUrl: './datiq-cell-change.component.html',
    styleUrls: ['./datiq-cell-change.component.scss'],
})
export class DatiqCellChangeComponent implements OnInit {
    @Input()
    settings: IDatiqCellChange;

    color: string;
    icon: string;
    isPositive: boolean;
    isNegative: boolean;

    constructor(private readonly _service: DatiqCellChangeService) {}

    ngOnInit(): void {
        this.color = this._service?.getColor(this.settings);
        this.icon = this._service?.getIcon(this.settings);

        this.isPositive = this._service.isPositive(this.settings);
        this.isNegative = this._service.isNegative(this.settings);
    }
}
